import React, { Component } from 'react';
import Loadable from 'react-loadable';
import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ReactGA from 'react-ga';
import * as locations from './components/Root/Const';
import { PersistGate } from 'redux-persist/integration/react'

import ThemeWrapper from './ThemeWrapper';

import LoginPage from './components/Login/LoginPage';
// import PageNotFoundPage from './components/PageNotFound/PageNotFoundPage';
// import RootPage from './components/Root/RootPage';
// import CreateAccountPage from './components/CreateAccount/CreateAccountPage';
// import SelectRegionPage from './components/SelectRegions/SelectRegionsPage';
// import SelectManagerPage from './components/SelectManager/SelectManagerPage';
// import RealtorsPage from './components/Realtors/RealtorsPage';
// import RealtorPage from './components/Realtor/RealtorPage';
// import PointDetailPage from './components/PointsDetail/PointsDetailPage';
// import PointsPage from './components/Points/PointsPage';
// import NotificationsPage from './components/Notifications/NotificationsPage';
// import NotificationPage from './components/Notification/NotificationPage';
// import CommunitiesPage from './components/Communities/CommunitiesPage';
// import RegionsPage from './components/Regions/RegionsPage';
// import RewardsPage from './components/Rewards/RewardsPage';
// import ViewOnHoldPointsPage from './components/ViewOnHoldPoints/ViewOnHoldPointsPage';
// import ViewClientRegistrationsPage from './components/ViewClientRegistrations/ViewClientRegistrationsPage';
// import MyPointsPage from './components/MyPoints/MyPointsPage';
// import MySubmittedPointsPage from './components/MySubmittedPoints/MySubmittedPointsPage';
// import ManageUsersPage from './components/ManageUsers/ManageUsersPage';
// import AddPointsPage from './components/AddPoints/AddPointsPage';
// import InformationPage from './components/Information/InformationPage';
// import LegalDisclaimerPage from './components/RulesLegal/RulesLegalPage';
// import OnHoldPointsPage from './components/OnHoldPoints/OnHoldPointsPage';
// import RegistrationPage from './components/Registration/RegistrationPage';
// import ProfilePage from './components/Profile/ProfilePage';
// import RegistrationPreviewPage from './components/RegistrationPreview/RegistrationPreviewPage'
// import CreateCompanyAccountPage from './components/CreateCompanyAccount/CreateCompanyAccountPage';
// import ComposeNotificationPage from './components/ComposeNotification/ComposeNotificationPage';
// import AdminSettingsPage from './components/AdminSettings/AdminSettingsPage';
// import EmailVerificationPage from './components/EmailVerification/EmailVerificationPage';
// import RegistrationRulesPage from './components/RegistrationRules/RegistrationRulesPage';


import configureStore from './store/configureStore';
import {Provider} from "react-redux";
// const store = configureStore();
const { persistor, store } = configureStore()


const PageNotFoundPage = Loadable({
  loader: () => import('./components/PageNotFound/PageNotFoundPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const RootPage = Loadable({
  loader: () => import('./components/Root/RootPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const CreateAccountPage = Loadable({
  loader: () => import('./components/CreateAccount/CreateAccountPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const SelectRegionPage = Loadable({
  loader: () => import('./components/SelectRegions/SelectRegionsPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const SelectManagerPage = Loadable({
  loader: () => import('./components/SelectManager/SelectManagerPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const RealtorsPage = Loadable({
  loader: () => import('./components/Realtors/RealtorsPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const RealtorPage = Loadable({
  loader: () => import('./components/Realtor/RealtorPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const PointDetailPage = Loadable({
  loader: () => import('./components/PointsDetail/PointsDetailPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const PointsPage = Loadable({
  loader: () => import('./components/Points/PointsPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const NotificationsPage = Loadable({
  loader: () => import('./components/Notifications/NotificationsPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const NotificationPage = Loadable({
  loader: () => import('./components/Notification/NotificationPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const CommunitiesPage = Loadable({
  loader: () => import('./components/Communities/CommunitiesPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const RegionsPage = Loadable({
  loader: () => import('./components/Regions/RegionsPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const RewardsPage = Loadable({
  loader: () => import('./components/Rewards/RewardsPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const ViewOnHoldPointsPage = Loadable({
  loader: () => import('./components/ViewOnHoldPoints/ViewOnHoldPointsPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const ViewClientRegistrationsPage = Loadable({
  loader: () => import('./components/ViewClientRegistrations/ViewClientRegistrationsPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const MyPointsPage = Loadable({
  loader: () => import('./components/MyPoints/MyPointsPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const MySubmittedPointsPage = Loadable({
  loader: () => import('./components/MySubmittedPoints/MySubmittedPointsPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const ManageUsersPage = Loadable({
  loader: () => import('./components/ManageUsers/ManageUsersPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const AddPointsPage = Loadable({
  loader: () => import('./components/AddPoints/AddPointsPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const InformationPage = Loadable({
  loader: () => import('./components/Information/InformationPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const LegalDisclaimerPage = Loadable({
  loader: () => import('./components/RulesLegal/RulesLegalPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const OnHoldPointsPage = Loadable({
  loader: () => import('./components/OnHoldPoints/OnHoldPointsPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const RegistrationPage = Loadable({
  loader: () => import('./components/Registration/RegistrationPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const ProfilePage = Loadable({
  loader: () => import('./components/Profile/ProfilePage'),
  loading() {
      return <div>Loading...</div>
  }
});

const RegistrationPreviewPage = Loadable({
  loader: () => import('./components/RegistrationPreview/RegistrationPreviewPage'),
  loading() {
      return <div>Loading...</div>
  }
});

const CreateCompanyAccountPage = Loadable({
  loader: () => import('./components/CreateCompanyAccount/passthrough'),
  loading() {
    return <div>Loading...</div>
  }
});

const ComposeNotificationPage = Loadable({
  loader: () => import('./components/ComposeNotification/ComposeNotificationPage'),
  loading() {
    return <div>Loading...</div>
  }
});

const AdminSettingsPage = Loadable({
  loader: () => import('./components/AdminSettings/AdminSettingsPage'),
  loading() {
    return <div>Loading...</div>
  }
});

const EmailVerificationPage = Loadable({
  loader: () => import('./components/EmailVerification/EmailVerificationPage'),
  loading() {
    return <div>Loading...</div>
  }
});

const RegistrationRulesPage = Loadable({
  loader: () => import('./components/RegistrationRules/RegistrationRulesPage'),
  loading() {
    return <div>Loading...</div>
  }
});

const BillingPage = Loadable({
  loader: () => import('./components/Billing/BillingPassthroughPage'),
  loading() {
    return <div>Loading...</div>
  }
});

const AutoNotificationsPage = Loadable({
  loader: () => import('./components/AutoNotifications/AutoNotificationsPage'),
  loading() {
    return <div>Loading...</div>
  }
});

const AdminBonusLevelsPage = Loadable({
  loader: () => import('./components/AdminBonusLevels/AdminBonusLevelsPage'),
  loading() {
    return <div>Loading...</div>
  }
});

const BonusLevelsPage = Loadable({
  loader: () => import('./components/BonusLevels/BonusLevelsPage'),
  loading() {
    return <div>Loading...</div>
  }
});

const PointSettingsPage = Loadable({
  loader: () => import('./components/PointSettings/PointSettingsPage'),
  loading() {
    return <div>Loading...</div>
  }
});

const EventsPage = Loadable({
  loader: () => import('./components/Events/EventsPage'),
  loading() {
    return <div>Loading...</div>
  }
});

const AddEventsPage = Loadable({
  loader: () => import('./components/AddEvents/AddEventsPage'),
  loading() {
    return <div>Loading...</div>
  }
});


class App extends Component {

  constructor() {
    super();

    // // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
    ReactGA.initialize('UA-113451769-1');
    // // This just needs to be called once since we have no routes in this case.
    ReactGA.pageview(window.location.pathname);
  }

  fireTracking() {
    ReactGA.pageview(window.location.pathname);
  }


  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeWrapper>
          <BrowserRouter> 
          <Switch>
            <Route exact path="/" component={LoginPage} onUpdate={this.fireTracking}/>
            <Route path={locations.loginPage} component={LoginPage} onUpdate={this.fireTracking}/>
            <Route path={locations.createAccountPage} component={CreateAccountPage} onUpdate={this.fireTracking} /> 
            <Route path={locations.CreateCompanyAccountPage} component={CreateCompanyAccountPage} onUpdate={this.fireTracking} />
            <Route path={locations.selectManagerPage} component={SelectManagerPage} onUpdate={this.fireTracking} />
            <Route path={locations.selectRegionPage} component={SelectRegionPage} onUpdate={this.fireTracking} />
            <Route path={locations.emailVerificationPage} component={EmailVerificationPage} onUpdate={this.fireTracking} />
            
            <RootPage>
              <Switch>
                <Route path={locations.realtorsPage} component={RealtorsPage} onUpdate={this.fireTracking} />
                <Route path={locations.addPointsPage} component={AddPointsPage} onUpdate={this.fireTracking} />
                <Route path={locations.onHoldPointsPage} component={OnHoldPointsPage} onUpdate={this.fireTracking} />
                <Route path={locations.realtorPage} component={RealtorPage} onUpdate={this.fireTracking} />
                <Route path={locations.pointDetailPage} component={PointDetailPage} onUpdate={this.fireTracking} />
                <Route path={locations.pointsPage} component={PointsPage} onUpdate={this.fireTracking} />
                <Route path={locations.notificationsPage} component={NotificationsPage} onUpdate={this.fireTracking} />
                <Route path={locations.notificationPage} component={NotificationPage} onUpdate={this.fireTracking} />
                <Route path={locations.informationPage} component={InformationPage} onUpdate={this.fireTracking} />
                <Route path={locations.legalDisclaimerPage} component={LegalDisclaimerPage} onUpdate={this.fireTracking} />
                <Route path={locations.registrationPage} component={RegistrationPage} onUpdate={this.fireTracking} />
                <Route path={locations.profilePage} component={ProfilePage} onUpdate={this.fireTracking} />
                <Route path={locations.registrationPreviewPage} component={RegistrationPreviewPage} onUpdate={this.fireTracking} />
                <Route path={locations.eventsPage} component={EventsPage} onUpdate={this.fireTracking} />
                

                <Route path={locations.myPointsPage} component={MyPointsPage} onUpdate={this.fireTracking} />

                <Route path={locations.mySubmittedPointsPage} component={MySubmittedPointsPage} onUpdate={this.fireTracking} />

                
                <Route path={locations.communitiesPage} component={CommunitiesPage} onUpdate={this.fireTracking} />
                <Route path={locations.regionsPage} component={RegionsPage} onUpdate={this.fireTracking} />
                <Route path={locations.rewardsPage} component={RewardsPage} onUpdate={this.fireTracking} />
                <Route path={locations.viewClientRegistrationsPage} component={ViewClientRegistrationsPage} onUpdate={this.fireTracking} />
                <Route path={locations.viewOnHoldPointsPage} component={ViewOnHoldPointsPage} onUpdate={this.fireTracking} />
                <Route path={locations.manageUsersPage} component={ManageUsersPage} onUpdate={this.fireTracking} />
                <Route path={locations.adminSettingsPage} component={AdminSettingsPage} onUpdate={this.fireTracking} />
                <Route path={locations.composeNotificationPage} component={ComposeNotificationPage} onUpdate={this.fireTracking} />
                <Route path={locations.registrationRulesPage} component={RegistrationRulesPage} onUpdate={this.fireTracking} />
                <Route path={locations.billingPage} component={BillingPage} onUpdate={this.fireTracking} />
                <Route path={locations.autoNotificationsPage} component={AutoNotificationsPage} onUpdate={this.fireTracking} />
                <Route path={locations.bonusLevelSettingsPage} component={AdminBonusLevelsPage} onUpdate={this.fireTracking} />
                <Route path={locations.bonusLevelsPage} component={BonusLevelsPage} onUpdate={this.fireTracking} />
                <Route path={locations.pointSettingsPage} component={PointSettingsPage} onUpdate={this.fireTracking} />
                <Route path={locations.addEventsPage} component={AddEventsPage} onUpdate={this.fireTracking} />

                <Route component={PageNotFoundPage} onUpdate={this.fireTracking} />
              </Switch>
            </RootPage>

          </Switch>
        </BrowserRouter>
        </ThemeWrapper>
      </PersistGate>
    </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js